import React from 'react';
import * as PropTypes from 'prop-types';
import { IdPropType } from '../../../proptypes/basic';
import MailInbox from './MailInbox';
import MailDrafts from './MailDrafts';
import {
    MAIL_FOLDER_INBOX,
    MAIL_FOLDER_DRAFTS,
} from '../constants';

const MailFolder = ({ customerId, mailId, selectedFolder, onChangeFolder }) => {
    switch (selectedFolder) {
        case MAIL_FOLDER_INBOX:
            return (
                <MailInbox
                    customerId={customerId}
                    mailId={mailId}
                    selectedFolder={selectedFolder}
                    onChangeFolder={onChangeFolder}
                />
            );

        case MAIL_FOLDER_DRAFTS:
            return (
                <MailDrafts
                    customerId={customerId}
                    selectedFolder={selectedFolder}
                    onChangeFolder={onChangeFolder}
                />
            );

        default:
            console.error(`Unknown mail folder selected: ${selectedFolder}`);
            return null;
    }
};

MailFolder.propTypes = {
    customerId: IdPropType,
    mailId: IdPropType,
    selectedFolder: PropTypes.string.isRequired,
    onChangeFolder: PropTypes.func.isRequired,
};

MailFolder.defaultProps = {
    customerId: null,
    mailId: null,
};

export default MailFolder;
